// Utility Function
export function convertPayRate(value, type) {
  if (!value || value === "N/A") return 0;

  const HOURS_PER_YEAR = 2080;
  const num = Number(value);

  if (isNaN(num)) return 0;

  const result =
    type === "hourly" ? num * HOURS_PER_YEAR : num / HOURS_PER_YEAR;

  if (result < 1) {
    return Number(result.toFixed(5));
  }

  return Math.round(result);
}

export const handleCopyClick = async ({ text, state }) => {
  try {
    await navigator.clipboard.writeText(text);
    state((prev) => ({
      ...prev,
      copied: true,
    }));
  } catch (error) {}
};

export const handleCopyMouseLeave = ({ state }) => {
  setTimeout(
    () =>
      state((prev) => ({
        ...prev,
        copied: false,
      })),
    200
  );
}
export const handleDataTime = (newValue, setUserData) => {
  if (!newValue) {
    setUserData((prev) => ({
      ...prev,
    }));
    return;
  };
  setUserData((prev) => ({
    ...prev,
    date_time: newValue,
  }));
};

export const CreatehandleDataTime = (newValue, setJobValue) => {
  if (!newValue) {
    setJobValue((prev) => ({ ...prev, submission_deadline: null }));
    return;
  }
  setJobValue((prev) => ({
    ...prev,
    submission_deadline: newValue.toISOString(),
  }));
};
